// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // baseUrl: 'https://api.4signing.com',
  // domainUrl: 'api.4signing.com',

  // baseUrl: 'https://api.dev.4signing.com',
  // domainUrl: 'api.dev.4signing.com',

  // baseUrl: 'http://192.168.1.100:2030',
  // domainUrl: '192.168.1.100:2030',

  baseUrl: 'http://localhost:2040',
  domainUrl: 'localhost:2040',

  reportUrl: 'http://localhost:2041',
  siteUrl: 'http://localhost:57542',
  payUrl: 'https://pay.aldawal.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
